// src/components/Login.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { getRedirectResult } from "firebase/auth";
import { auth } from "../firebase";
import { useAuth } from '../AuthContext';
import { getAuth, signInWithPopup, GoogleAuthProvider, onAuthStateChanged, signOut } from "firebase/auth";

const provider = new GoogleAuthProvider();

const Login = () => {
  const [user1, setUser] = useState(null);
  const [loading1, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  const { user, loading, loginWithGoogle, logout } = useAuth();
  
  const navigate = useNavigate();
  const apiServer = process.env.REACT_APP_API_SERVER_URL ?? '/api/';
  
  // 1. If the user is already logged in, send them to home immediately
  useEffect(() => {
    if (user) {
		//alert('Login:navigate /')
      signinApi();
      navigate("/", { replace: true });
    }
  }, [user, navigate]);


  // Handle the persistent login state
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handlePopupLogin = async () => {
    try {
      // This opens the Google selection window
      const result = await signInWithPopup(auth, provider);
      console.log("Logged in as:", result.user.displayName);
    } catch (error) {
      console.error("Login failed:", error.code, error.message);
    }
  };

  const handleLogout = () => signOut(auth);

  const signinApi = async () => {
    try {
      const response = await fetch(apiServer + 'signin?profile_email='+user?.email, {method: 'GET',headers: {'Content-Type': 'application/json',},});
      if (!response.ok) {
        const errorData = await response.json();
        alert(`Error: ${errorData.detail || 'Failed to submit'}`);
      }
    } catch (error) {
      console.error("Connection Error:", error);
      alert("Could not connect to the server at " + apiServer + ". Is your backend running?" + error);
    } finally {
    }
  };

  if (loading) return <div>Checking session...</div>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '50px' }}>
      {user1 ? (
        <>
          <h1>Hello, {user1.displayName}</h1>
          <img src={user1.photoURL} alt="profile" style={{ borderRadius: '50%', width: '100px' }} />
          <button onClick={handleLogout} style={{ marginTop: '20px' }}>Logout</button>
        </>
      ) : (
        <>
          <h1>Login</h1>
          <button onClick={handlePopupLogin} style={{ padding: '10px 20px' }}>
            Sign in with Google (Popup)
          </button>
        </>
      )}
    </div>
  );
};  
  
export default Login;
